<template>
  <div class="wrapper">
    <div class="result">
        <div class="order-id">订单编号：{{order_id}}</div>
        <div class="order-time">下单时间：{{orderTime}}</div>
        <div class="list-head order-box">
          <div class="order-list">订单详情</div>
        </div>
        <div class="order-box list-box">
          <div class="order-list" v-if="orderInfo.order_type==9">
              <DesTable v-if="orderInfo.mark&&orderInfo.customized_status>=4" :price="orderInfo.order_amount" :configstr="orderInfo.mark" :file_path="orderInfo.file_path" :imgurl_path="orderInfo.imgurl_path"></DesTable>
          </div>
        </div>
    </div>

      <div class="a-box" v-if="orderInfo.aftersalesItem&&orderInfo.aftersalesItem[0]&&orderInfo.aftersalesItem[0].mark">
          <span class="a-label top10">说明：</span>
          <div class="a-main">
              <span class="a-label top10">
                {{orderInfo.aftersalesItem[0].mark}}
              </span>
          </div>
      </div>

    <div class="a-box">
      <span class="a-label top10">下载物料清单：</span>
      <div class="a-main">
        <div>
            <div class="el-upload__tip">请下载下方物料清单，填写要退回的物料数量，重新在本页面上传，我们会根据您上传的物料清单进行审核</div>
          <br>
          <a target="_blank" :download="orderInfo.wuliao_path" :href="orderInfo.wuliao_path">
            <img class="Excelicon" src="~@/assets/image/Excelicon.png">
          </a>
        </div>
      </div>
    </div>
    <div class="a-box">
      <span class="a-label top10">上传物料清单：</span>
      <div class="a-main">
        <el-upload
                :action="upLoadUrl"
                :on-exceed="handleExceedVisio"
                class="el-form-item__content"
                :limit="1"
                :on-remove="handleRemove"
                :http-request="e=>handleUpload(e)"
        >
          <el-button size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">只能上传rar/zip/xlsx/xls文件，且不超过500M</div>
          <div v-if="!images.length" class="el-form-item__error">
            请上传文件
          </div>
        </el-upload>
      </div>
    </div>
    <div class="submit" @click="handleSubmit">提交</div>
  </div>
</template>

<script>
import { timeToDate, formatMoney} from "@/utils";
import {apiBaseUrl} from "@/config/env.js";
import DesTable from '@/components/zqtool/DesTable.vue';
export default {
  name: "RefundApply",
  components: {DesTable},
  props: {},
  data() {
    return {
      order_id: "",
      orderTime: "",
      type: "1",
      dialogImageUrl: "",
      dialogVisible: false,
      isDisabled: false, //是否禁用退货
      items: [], //商品列表
      refund: 0, //退款价格
      refund_show: 0, //可输入最大退款金额
      reason: "", //退款原因
      images: [],
      upLoadUrl: apiBaseUrl + "api.html",
      listData:{},
      orderInfo:{},
    };
  },
  watch: {},
  computed: {
    moneyData () {
      if(this.listData.order_amount) {
        return formatMoney((this.listData.order_amount - this.listData.refunded), 2, '');
      }
    },
    item_ids () {
      let selectItems = this.items.filter(item => {
        return item.checked;
      });
      let item_ids = [];
      if (this.type == 1) {
        selectItems.forEach(item => {
          item_ids.push({
            id: item.id,
            // nums: item.nums,
            nums: item.returnNums

          });
        });
      } else {
        selectItems.forEach(item => {
          if (item.sendnums > item.reship_nums) {
            let nums = item.sendnums - item.reship_nums;
            console.log(nums)
            item_ids.push({
              id: item.id,
              // nums: item.nums,
              nums: item.returnNums
            });
          }
        });
      }
      return item_ids;
    }
  },
  methods: {
    //上传图片
    handleExceedVisio() {
      this.$message.warning(`当前限制选择 1 个文件，请删除后继续上传！`)
    },
    //上传图片
    handleUpload(e) {
      var formdata = new FormData();
      formdata.append("upfile", e.file, e.file.name);
      this.$api.uploadImage(this.upLoadUrl, formdata).then(res => {
        if (res.status) {
          this.images = this.images.concat(res.data.image_id);
        } else {
          this.$msg(res.msg, "error");
        }
      });
    },
    handleSubmit() {
        if(this.images.length==0){
            this.$msg("请上传物料清单", "error");
            return false;
        }
console.log("this.images",this.images);
      let data = {
        order_id: this.order_id,
        type: 2,
        items: this.item_ids,
        images: this.images,
        refund: 0,
        reason: "租赁回收物料"
      };

      this.$api.addAfterSales(data).then(res => {
        if (res.status) {
          this.$msg("提交成功");
          this.$router.replace({name: 'myquiteorder'})
        } else {
          this.$msg(res.msg, "error");
        }
      });
    },
    radioChange(val) {
      console.log(val)
      this.refund = this.refund_show;
    },
    changeSelected(item, index) {
      if (item.checked) {
        this.items[index].checked = false;
      } else {
        this.items[index].checked = true;
      }
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
      this.images = [];
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    //获取订单商品信息
    getOrderInfo() {
      let data = {
        order_id: this.order_id
      };
      this.$api.orderDetail(data).then(res => {
        if (res.status) {
          //如果不是未支付的，已取消的，已完成的状态，就都可以售后
          if (
            res.data.text_status != 1 &&
            res.data.text_status != 6 &&
            res.data.text_status != 7
          ) {

            this.refund = (res.data.payed - res.data.refunded).toFixed(2);
            this.refund_show = res.data.payed - res.data.refunded;
            this.orderTime = timeToDate(res.data.ctime);
            this.orderInfo=Object.assign({},this.orderInfo,res.data);
          } else {
            this.$msg("订单不可以进行售后", "error");
          }
          this.listData = res.data
        } else {
          this.$msg("没有找到此订单", "error");
        }
      });
    }
  },
  created() {},
  mounted() {
    let order_id = this.$route.params.order_id;
    this.order_id = order_id;
    this.getOrderInfo();
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/variable.scss";
.result {
  margin-bottom: 20px;
}
.order-id, .order-time {
  margin-bottom: 10px;
}
.order-box {
  display: flex;
  text-align: center;
  align-items: center;
  &.list-head {
    height: 40px;
    line-height: 40px;
    background: $theme-bg;
  }
  &.list-box {
    border-bottom: 1px solid $border;
    // border-top: none;
    // border-left: 0;

    .order-list {
      display: inline-flex;
      border-left: 1px solid $border;
      border-right: 1px solid $border;
      padding: 20px 0;
      display: flex;
      flex-direction: column;
      .product-item {
        // margin: 0 10px;
        padding: 0 10px;
        display: flex;
        flex-direction: row;
        align-items: center;
        border-bottom: 1px solid #eee;
        padding: 10px;
        &:last-child {
          border: none;
        }
        .product-img {
          display: inline-block;
          width: 50px;
          height: 50px;
          flex: 0 0 50px;
          object-fit: cover;
          // margin-bottom: 10px;
        }
        .shop-info {
          display: flex;
          flex-direction: column;
          flex: 1;
          padding: 0 20px;
          align-items: flex-start;
          text-align: left;
          font-size: 12px;
          .title {
            width: 700px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            margin-bottom: 10px;
          }
          .desc {
            input {
              border: 1px solid #eee;
              width: 40px;
              height: 24px;
              text-align: center;
            }
          }
        }
        .apply-btn {
          width: 50px;
          height: 20px;
          line-height: 20px;
          border: 1px solid $border;
          cursor: pointer;
          color: $theme-color;
          font-size: 12px;
          flex: 0 0 50px;
          &.active {
            background: $theme-color;
            color: #fff;
          }
          &:hover {
            background: $theme-color;
            color: #fff;
          }
        }
      }
    }
  }
  .order-id {
    width: 200px;
  }
  .order-list {
    flex: 1;
  }
  .order-time {
    width: 200px;
  }
}
.a-box {
  display: flex;
  margin-bottom: 10px;
  padding: 8px 0;
  &.money {
    .a-main {
      display: flex;
      flex-direction: column;
      .desc {
        font-size: 12px;
        margin-top: 10px;
      }
    }
  }
  .a-label {
    display: inline-block;
    width: 100px;
    text-align: right;
    margin-right: 20px;
    &.top10 {
      margin-top: 10px;
    }
  }
  .a-main {
    display: inline-flex;
    .a-img {
      width: 75px;
      height: 75px;
      display: inline-block;
      object-fit: cover;
      margin-right: 20px;
    }
    .a-name {
      display: inline-block;
    }
    .a-price-input {
      display: block;
      width: 180px;
      height: 30px;
      text-indent: 10px;
      color: $theme-color;
      font-size: 16px;
      border: 1px solid $border;
    }
    .textarea {
      width: 480px;
      resize: none;
      border: 1px solid $border;
      padding: 10px;
      &:focus {
        outline: none;
        border-color: $theme-color;
      }
    }
  }
}
.submit {
  width: 200px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  background: $theme-color;
  color: #fff;
  margin-left: 120px;
  margin-top: 30px;
  cursor: pointer;
}
.radio {
  margin-right: 10px;
}
  .Excelicon{ width: 150px; cursor: pointer}
</style>